import React from 'react'
import { Button, IconButton, Menu, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { NavLink } from 'react-router-dom'
import { formatRoute } from 'react-router-named-routes'
import { NamedRoutes } from '../../../../routes'
import { TableRowBackground } from '../../../../utils/colors'
import { useStyles } from './Styles'
import DeleteCurrency from './DeleteCurrency'

const CurrencyMenu = ({ index, data, setData, setCount }) => {
  let classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [viewPageMenu, setViewPageMenu] = React.useState(false)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setViewPageMenu(true)
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setViewPageMenu(false)
  }

  const StyledMenu = withStyles({
    paper: {
      border: `1px solid ${TableRowBackground}`
    }
  })((props) => (
    <Menu
      elevation={4}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      disableScrollLock
      {...props}
    />
  ))

  const [viewDeleteCurrencyDialog, setViewDeleteCurrencyDialog] = React.useState(false)
  const [openDeleteCurrencyDialog, setOpenDeleteCurrencyDialog] = React.useState(false)
  const handleDeleteCurrencyDialog = () => {
    if (!openDeleteCurrencyDialog) {
      setViewDeleteCurrencyDialog(true)
    } else {
      setTimeout(() => setViewDeleteCurrencyDialog(false), 500)
    }
    setOpenDeleteCurrencyDialog(!openDeleteCurrencyDialog)
  }

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon/>
      </IconButton>
      {!!viewPageMenu &&
      <StyledMenu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        className={classes.UserCustomMenu}
      >
        <MenuItem onClick={handleClose}>
          <NavLink to={formatRoute(NamedRoutes.workspace.currencies.edit, { id: data[index].id })}>
            <FormattedMessage id='UserMenu.editPage'/>
          </NavLink>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Button color="primary" onClick={handleDeleteCurrencyDialog}>
            <FormattedMessage id='UserMenu.deletePage'/>
          </Button>
        </MenuItem>
      </StyledMenu>
      }
      <DeleteCurrency
        index={index}
        data={data}
        setData={setData}
        setCount={setCount}
        handleDeleteCurrencyDialog={handleDeleteCurrencyDialog}
        viewDeleteCurrencyDialog={viewDeleteCurrencyDialog}
        openDeleteCurrencyDialog={openDeleteCurrencyDialog}/>
    </div>
  )
}

export default CurrencyMenu
